module.exports = __webpack_public_path__ + "static/media/Dylan Snyder.63e75af3.png";